export default __webpack_public_path__ + "static/media/SignIn_Black_Business.a1a3f9e7.svg";